import { combineReducers } from "redux";
// import userReducer from './userReducers'
import userDataStore from "./userReducers";
import { authStore, changePassStore, forgotPassStore } from "./authReducers";
import {
  amenityReducer,
  configurationReducer,
  followUpMasterReducer,
  getCityListMasterReducer,
  insentiveTypeReducer,
  masterReducer,
  propertyTypeReducer,
  statusReducer,
  paymentTypeReducer,
  ethnicityReducer
} from "./masterReducers";
import authRegisterAddReducer from "./authRegisterAddReducers";
import { roleReducer } from "./roleReducers";
import modulesReducer from "./moduleReducers";
import {
  propConfiListReducer,
  propertyFormReducer,
  propertyReducer,
} from "./propertyReducers";
import followUpStore from "./followUpReducers";
import channelPartnerStore, { employeeEmailMobileCheck, geSMlistReducer, getCPCurrentMapingData ,cpSmstore } from "./channelPartnerReducers";
import visitorReducer, {
  verifyVisitFormReducer,
  visitFormReducer,
  visitorFormReducer,
  visitorMobileCheckReducer,
} from "./visitorReducers";
import configurationSettingReducer from "./configurationSettingReducers";
import dashboardDataStore from "./dashboardReducers";
import appointmentStore, {
  appointmentFormReducer,
  assignClosingManagerStore
} from "./appointmentReducers";
import userProfileDataStore from "./userProfileReducer";
import supportForumStore from "./supportForumReducer";
import permissionReducer from "./permissionReducers";
import raiseTicketStore from "./raiseTicket(Support)Reducers";
import { chatReducer } from "./chatReducers";
import {bookingReducer,addBookingReducer} from "./bookingReducers";
import registrationReducer from "./registrationReducers";
import reportDataStore from "./reportReducers";
import webReportReducer from "./webReportReducers";
import { EmployeeReducer } from "./companyReducer";
import  closingManagerStore  from "./closingManagerReducer"
import sourcingManagerStore from './sourcingManagerReducer'
import userAppointmentStore from "./userAppointmentReducer"
import siteVisitStore from "./siteVisitReducer"

export default combineReducers({
  login: authStore,
  forgotPassword: forgotPassStore,
  changePassword: changePassStore,
  dashboardDetailAdmin: dashboardDataStore,
  Register_AddUserData: authRegisterAddReducer,
  userData: userDataStore,
  masterData: masterReducer,
  cityMasterData: getCityListMasterReducer,
  propertyTypes: propertyTypeReducer,
  configurations: configurationReducer,
  amenities: amenityReducer,
  paymentTypes:paymentTypeReducer,
  followupstatus: statusReducer,
  insentiveTypes: insentiveTypeReducer,
  followUpMaster: followUpMasterReducer,
  modules: modulesReducer,
  roleData: roleReducer,
  propertyData: propertyReducer,
  propertyForm: propertyFormReducer,
  followUp: followUpStore,
  channelPartner: channelPartnerStore,
  sourcingManagerList: geSMlistReducer,
  cpMapingData: getCPCurrentMapingData,
  visitor: visitorReducer,
  visitorForm: visitorFormReducer,
  visitorConfiguration: configurationReducer,
  configurationSettingDetail: configurationSettingReducer,
  appointment: appointmentStore,
  appointmentForm: appointmentFormReducer,
  userProfileUpdate: userProfileDataStore,
  supportForum: supportForumStore,
  permission: permissionReducer,
  bulkVisitForm: visitFormReducer,
  bulkVerifyVisitForm: verifyVisitFormReducer,
  propConfigurationList: propConfiListReducer,
  raiseTicket: raiseTicketStore,
  chatResponse: chatReducer,
  booking: bookingReducer,
  addBooking:addBookingReducer,
  registration: registrationReducer,
  report: reportDataStore,
  webreport:webReportReducer,
  visitorMobileCheck: visitorMobileCheckReducer,
  empEmailMobileCheck: employeeEmailMobileCheck,
  companydata: EmployeeReducer,
  cmData:closingManagerStore,
  smData:sourcingManagerStore,
  cpAppointment:userAppointmentStore,
  allocatedClosing:assignClosingManagerStore,
  cpSmData:cpSmstore,
  ethnicitys:ethnicityReducer,
  siteVisit: siteVisitStore
});
